'use client';
import React from 'react';
import { BenzingaQuiz } from '@benzinga/ui';

export interface RiverdropQuizBlockProps {
  form_factor?: string;
  partner_id: string;
  quiz_id?: string;
}

export const RiverdropQuizBlock: React.FC<RiverdropQuizBlockProps> = ({
  form_factor = 'desktop',
  partner_id,
  quiz_id = '',
}) => {
  return <BenzingaQuiz form_factor={form_factor} partner_id={partner_id} quiz_id={quiz_id} />;
};
